import type { DrainageResult, SaunaSiting } from '../../engines/types';
import type { Market } from '../location/types';
import { getT } from '../../i18n';

interface DrainageInput {
  includesShower: boolean;
  siting?: SaunaSiting;
}

export function calculateDrainage({ includesShower, siting }: DrainageInput, market: Market = 'se'): DrainageResult {
  const t = getT(market);

  // Issue 156: indoors there is no ground under the sauna to drain — the
  // advice is about the existing floor and the room's own drain instead.
  if (siting === 'indoor') {
    return includesShower
      ? {
          status: 'warning',
          requiresFloorDrain: true,
          slopeRule: t.domain_drain_slopeShower,
          pipeRecommendation: t.domain_drain_indoorPipeShower,
          foundationAdvice: [t.construction_showerScope, t.domain_drain_indoorAdviceWetRoom],
          instructionLabel: t.domain_drain_indoorInstrShower,
        }
      : {
          status: 'ok',
          requiresFloorDrain: false,
          slopeRule: t.domain_drain_indoorSlopeNoShower,
          pipeRecommendation: t.domain_drain_indoorPipeNoShower,
          foundationAdvice: [t.domain_drain_indoorAdviceFloor],
          instructionLabel: t.domain_drain_indoorInstrNoShower,
        };
  }

  if (includesShower) {
    return {
      status: 'warning',
      requiresFloorDrain: true,
      slopeRule: t.domain_drain_slopeShower,
      pipeRecommendation: t.domain_drain_pipeShower,
      foundationAdvice: [
        t.construction_showerScope,
        t.domain_drain_adviceShower1,
        t.domain_drain_adviceShower2,
      ],
      instructionLabel: t.domain_drain_instrShower,
    };
  }

  return {
    status: 'ok',
    requiresFloorDrain: false,
    slopeRule: t.domain_drain_slopeNoShower,
    pipeRecommendation: t.domain_drain_pipeNoShower,
    foundationAdvice: [
      t.domain_drain_adviceNoShower1,
      t.domain_drain_adviceNoShower2,
    ],
    instructionLabel: t.domain_drain_instrNoShower,
  };
}
